import React from 'react'

import SectionHero from '../components/SecctionHero/SecctionHero'
import SectionWhy from '../components/SectionWhy/SectionWhy'
import SectionRecommendations from '../components/SectionRecommendations/SectionRecommendations'
import SectionColab from '../components/SectionColab/SectionColab'
import FaqSection from '../components/FaqSection/FaqSection'
import SectionInfo from '../components/SectionInfo/SectionInfo'
import Footer from '../components/Footer/Footer'

const Home = () => {
  return (
    <div>
      <SectionHero />
     <SectionWhy />
      <SectionRecommendations id="recommendations"/>
      <SectionColab />
      <FaqSection />
      <SectionInfo />
      {/* <Footer /> */}
    </div>
  )
}

export default Home
